import { notification } from 'antd';

export default (message) => {
  notification.success({
    message: 'Success',
    description: message,
    placement: 'bottomRight',
  });
};
